import React from "react";
import {
  Container,
  Row,
  Col,
  TabContent,
  TabPane,
  Button
} from "reactstrap";

function Tab2({ activeTab, updateActiveTab, AdminUserid }) {
  const handleExportClick = () => {
    console.log("Export button clicked by " + AdminUserid);
    // Add export logic here
  };

  const handleBackClick = () => {
    updateActiveTab("1");
  };

  return (
    <div>
      <TabContent activeTab={activeTab} className="mt-4">
        <TabPane tabId="2" id="export-tab">
          <Container className="bg-white p-4 rounded">
            <h4 className="card-title mb-4">Export Proceeds</h4>
            <p>Export all client proceeds to a CSV file. This will allow you to save the current data and use it externally.</p>
            <Row className="mb-4">
              <Col>
                <Button color="primary" onClick={handleExportClick}>
                  Export
                </Button>
                <Button color="secondary" className="ml-2" onClick={handleBackClick}>
                  Back
                </Button>
              </Col>
            </Row>
          </Container>
        </TabPane>
      </TabContent>
    </div>
  );
}

export default Tab2;
